import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Typography,
  Tabs,
  Tab,
} from "@mui/material";
import erwin from "../assets/erwin.jpg";
import banner from "../assets/banner.jpg";
import { Link, Outlet, useLocation } from "react-router-dom";
import { ConstructionBanner } from "../components/ConstructionBanner";

export const Home = () => {
    const location = useLocation();
    
  return (
    <Box sx={{ minHeight: "100vh", pb: 4, backgroundColor: "#f7f7f7" }}>
      {/* Banner */}
      <Box
        sx={{
          width: "100%",
          height: 260,
          backgroundImage: `url(${banner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderBottomLeftRadius: "6px",
          borderBottomRightRadius: "6px",
        }}
      />

      {/* Profile Section */}
      <Container
        maxWidth="md"
        sx={{
          textAlign: "center",
          marginTop: "-175px",
        }}
      >
        <Avatar
          src={erwin}
          sx={{
            width: 250,
            height: 250,
            border: "5px solid white",
            boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            margin: "auto",
          }}
        />

        <Typography
          variant="h3"
          fontFamily={"Amsterdam"}
          fontWeight="bold"
          lineHeight={3}
        >
          Erwin Van Brussel
        </Typography>

        <Typography variant="subtitle1">
          23 November 1975 - 17 November 2025
        </Typography>
        {/* <Typography variant="subtitle2" sx={{ color: "text.secondary" }}>
          Boom, België
        </Typography> */}

        {/* Action Buttons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 3,
          }}
        >
          <Button
            variant="contained"
            startIcon={<span>🌳</span>}
            href={"https://bosplus.be/schenk-een-boom/"}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              backgroundColor: "#e8f5e9",
              color: "#2e7d32",
              borderRadius: "30px",
              textTransform: "none",
              fontWeight: 500,
              px: 3,
              py: 1.2,
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
              "&:hover": {
                backgroundColor: "#d7f0dc",
                boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
              },
            }}
          >
            Schenk een boom
          </Button>
        </Box>

        {/* Section Tabs (Optional) */}
        <Tabs
          value={location.pathname.length > 1 ? location.pathname.replace(/\/$/, "") : location.pathname}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            mt: 4,
            "& .MuiTabs-flexContainer": {
              justifyContent: "center" ,
            },
          }}
        >
          <Tab label="Erwin" value="/" component={Link} to="/" />
          <Tab
            label="Begrafenis"
            value="/begrafenis"
            component={Link}
            to="begrafenis"
          />
          <Tab
            label="Gallerij"
            value="/gallerij"
            component={Link}
            to="gallerij"
          />
          <Tab
            label="Herinnering"
            value="/herinnering"
            component={Link}
            to="herinnering"
          />
        </Tabs>

        {/* Content Area */}
        <Card sx={{ mt: 4, boxShadow: 2 }}>
          <CardContent>
            <Outlet />
          </CardContent>
        </Card>

        <ConstructionBanner />
      </Container>
    </Box>
  );
};
